import { Cabin } from '@gecko-akh/pkg-cruise-api-types/src/iris'
import { handleError } from '../../../general/errorHandling'
import { CABIN_TYPE_SORT_ORDER, COMFORTAI, IND, INDAI } from '../../../general/master-data'
import { useDetailsStore } from '../index.js'
import { useCabinStore } from './index.js'
import { CabinCategory } from './interfaces'

export const cabinTypes = (): string[] => {
    const cabinStore = useCabinStore()
  
    const categories: CabinCategory[] = cabinStore.categories
    const types = []

    if (!categories.length) {
      handleError({ error: new Error('no Categories'), origin: 'availableTypesForPriceModel' })
      return []
    }
  
    for (const type of CABIN_TYPE_SORT_ORDER) {
      for (const category of categories) {
        if (category.available && category.type === type) {
          types.push(type)
          break
        }
      }
    }
    return types
}

export const matchingCategories = (): CabinCategory[] => {
  const detailsStore = useDetailsStore()
  const cabinStore = useCabinStore()

  const priceModel = detailsStore.priceModel!
  const type: string = cabinStore.type
  const categories: CabinCategory[] = cabinStore.categories

  if (!categories.length) {
    handleError({ error: new Error('no cabin categories available'), origin: 'matchingCategories' })
    return categories
  }

  if ([COMFORTAI, IND, INDAI].includes(priceModel)) {
    return categories.filter(category => category.type === type)
  }

  return categories
}

export const matchingCabins = (): Cabin[] => {
  const cabinStore = useCabinStore()

  const category: CabinCategory | null = cabinStore.category
  const cabins = cabinStore.cabins

  if (!!category && !!cabins.length) {
    return cabins.filter(cabin => cabin.cabinCategory === category.id)
  }

  return []
}

export default {
  cabinTypes,
  matchingCategories,
  matchingCabins,
}
